import React from 'react'
import Section from './Section'
import { Card, Col, Row, Stack } from 'react-bootstrap'
import { IconOnCircle } from '../../components/icon-on-circle'

export const KeyBenefits = () => {
  return (
    <Section title="Key benefits when using our products">
      <Row className="g-3 g-md-5">
        <BenefitContainer
          icon="dumpster"
          title="No more sawing and filing"
          description="Faster than any traditional sawing or machining methods. A great time saver!"
        />
        <BenefitContainer
          icon="pencil-ruler"
          title="Precise measurement everytime"
          description="Create an accurate, square and “burr free” opening, exactly to size, every time."
          iconColor="secondary"
        />
        <BenefitContainer
          icon="toolbox"
          title="Portable!"
          description="Great for field upgrades and modifications."
          iconColor="success"
        />
        <BenefitContainer
          icon="hard-hat"
          title="Hardened/virgin tool steel"
          description="Die sets are manufactured from virgin tool steel, hardened throughout, and plated for years of reliable service."
          iconColor="danger"
        />
        <BenefitContainer
          icon="ruler-combined"
          title="Custom sizes and specialty units"
          description="Custom sizes and specialty units available in each of our product series, just send us your specifications."
          iconColor="info"
        />
        <BenefitContainer
          icon="tools"
          title="Manual or hydraulic"
          description="Models available for use with manual and hydraulic pulling methods."
          iconColor="warning"
        />
      </Row>
    </Section>
  )
}

const BenefitContainer = ({ icon, title, description, iconColor = 'primary' }) => {
  return (
    <Col md={4}>
      <Card className="justify-content-center align-items-center  ">
        <div className="py-4">
          <IconOnCircle icon={icon} className={`bg-${iconColor} p-4`} />
        </div>

        <Card.Body>
          <Stack className="align-items-center justify-content-center ">
            <h5 className="fw-bold">{title}</h5>
            <p>{description}</p>
          </Stack>
        </Card.Body>
      </Card>
    </Col>
  )
}
